import { t } from "i18next";
import { getDataUserByKey, getTenantInfoByKey } from "../../helpers/helpers";

const instanceHasOpenings = getTenantInfoByKey('is_access_opening');
const instanceHasBuildings = getTenantInfoByKey('is_building');

const nameOfArea = getTenantInfoByKey('area_name');
const nameOfBuildings = getTenantInfoByKey('building_name');
const nameOfOpenings = getTenantInfoByKey('opening_name');

export const OPENINGS = 'openings';
export const BUILDINGS = 'buildings';
export const AREAS = 'areas';

export const resTypesInitial = {
    employeesIn: true,
    vehiclesIn: true,
    visitorsIn: true
};

export const checkResTypesSelected = (typesLoaded) => {
    const resourcesTypes = {
        employeesIn: false,
        vehiclesIn: false,
        visitorsIn: false
    }
    typesLoaded.forEach(el => {
        if (el === 'EMP') resourcesTypes.employeesIn = true;
        if (el === 'VEH') resourcesTypes.vehiclesIn = true;
        if (el === 'VIS') resourcesTypes.visitorsIn = true;
    });
    return resourcesTypes;
}

export const getLevelsToWidgetByResources = () => {
    const conditions = {
        openings: instanceHasOpenings,
        buildings: instanceHasBuildings,
        areas: instanceHasBuildings,
        // Agrega más condiciones si es necesario
    };

    return Object.keys(conditions).filter(key => conditions[key]);
};

export const widgetNameByUserAndInfo = (levelSelected, levels, havePermissionToEntryOrDeparture, openingSelected, buildingSelected, openingSelectedInWidget, buildingSelectedInWidget, resources) => {

    const languageDetected =  getDataUserByKey('lang')  || getTenantInfoByKey('language') || 'es';

    const isGuard = Number(getDataUserByKey('access_profile_id')) === 3;

    const resourcesInPlant = t('RES_ENTERED');

    const openingSelectedToWidget = openingSelected.codigo === "" ? openingSelectedInWidget : openingSelected.descripcion;
    const buildingSelectedToWidget = buildingSelected.buildingCode === "" ? buildingSelectedInWidget : buildingSelected.buildingDescription;

    const openingWithoutOrMoreBuildingsText = `${resourcesInPlant} de ${openingSelectedToWidget}`;

    const buildingsResourcesText = `Recursos por ${nameOfBuildings} de ${openingSelectedToWidget}`;
    const buildingWithoutOrMoreAreasText = `${resourcesInPlant} de ${buildingSelectedToWidget}`;

    const areasResourcesTextWithOpening = `Recursos por ${nameOfArea} del ${buildingSelectedToWidget} de ${openingSelectedToWidget}`;
    const areasResourcesTextWithBuilding = `Recursos por ${nameOfArea} del ${buildingSelectedToWidget}`;

    const languages = {
        es: {
            openingResources: `Recursos por ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: openingWithoutOrMoreBuildingsText,
            buildingsResources: buildingsResourcesText,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: buildingWithoutOrMoreAreasText,
            areasSelectedWithOpening: areasResourcesTextWithOpening,
            areasSelectedWithBuilding: areasResourcesTextWithBuilding,
            onlyBuildings: nameOfBuildings,
        },
        en: {
            openingResources: `Resources by ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: `${resourcesInPlant} of ${openingSelectedToWidget}`,
            buildingsResources: `Resources by ${nameOfBuildings} from ${openingSelectedInWidget}`,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: `${resourcesInPlant} of ${buildingSelectedToWidget}`,
            areasSelectedWithOpening: `Resources by ${nameOfArea} of ${buildingSelectedToWidget} of ${openingSelectedToWidget}`,
            areasSelectedWithBuilding: `Resources by ${nameOfArea} of ${buildingSelectedToWidget}`,
            onlyBuildings: nameOfBuildings,
        },
        it: {
            openingResources: `Risorse per ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: `${resourcesInPlant} di ${openingSelectedToWidget}`,
            buildingsResources: `Risorse per ${nameOfBuildings} di ${openingSelectedInWidget}`,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: `${resourcesInPlant} di ${buildingSelectedToWidget}`,
            areasSelectedWithOpening: `Risorse per ${nameOfArea} di ${buildingSelectedToWidget} di ${openingSelectedToWidget}`,
            areasSelectedWithBuilding: `Risorse per ${nameOfArea} di ${buildingSelectedToWidget}`,
            onlyBuildings: nameOfBuildings,
        },
        br: {
            openingResources: `Recursos para ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: `${resourcesInPlant} de ${openingSelectedToWidget}`,
            buildingsResources: `Recursos para ${nameOfBuildings} de ${openingSelectedInWidget}`,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: `${resourcesInPlant} de ${buildingSelectedToWidget}`,
            areasSelectedWithOpening: `Recursos para ${nameOfArea} del ${buildingSelectedToWidget} de ${openingSelectedToWidget}`,
            areasSelectedWithBuilding: `Recursos para ${nameOfArea} del ${buildingSelected}`,
            onlyBuildings: nameOfBuildings,
        },
        mx: {
            openingResources: `Recursos por ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: openingWithoutOrMoreBuildingsText,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: buildingWithoutOrMoreAreasText,
            areasSelectedWithOpening: areasResourcesTextWithOpening,
            areasSelectedWithBuilding: areasResourcesTextWithBuilding,
            onlyBuildings: nameOfBuildings,
            buildingsResources: buildingsResourcesText,
        },
        ch: {
            openingResources: `Recursos por ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: openingWithoutOrMoreBuildingsText,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: buildingWithoutOrMoreAreasText,
            areasSelectedWithOpening: areasResourcesTextWithOpening,
            areasSelectedWithBuilding: areasResourcesTextWithBuilding,
            onlyBuildings: nameOfBuildings,
            buildingsResources: buildingsResourcesText,
        },
        pe: {
            openingResources: `Recursos por ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: openingWithoutOrMoreBuildingsText,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: buildingWithoutOrMoreAreasText,
            areasSelectedWithOpening: areasResourcesTextWithOpening,
            areasSelectedWithBuilding: areasResourcesTextWithBuilding,
            onlyBuildings: nameOfBuildings,
            buildingsResources: buildingsResourcesText,
        },
        ec: {
            openingResources: `Recursos por ${nameOfOpenings}`,
            openingSelected: openingSelected?.descripcion,
            openingWithoutOrMoreBuildings: openingWithoutOrMoreBuildingsText,
            buildingSelected: buildingSelected?.buildingDescription,
            buildingWithoutOrMoreAreas: buildingWithoutOrMoreAreasText,
            areasSelectedWithOpening: areasResourcesTextWithOpening,
            areasSelectedWithBuilding: areasResourcesTextWithBuilding,
            onlyBuildings: nameOfBuildings,
            buildingsResources: buildingsResourcesText,
        },
    }

    //when the instance has more than 20 openings or buildings or areas
    if (resources[0] && resources[0].entityCode === null) {
        if (isGuard && buildingSelected.buildingCode !== "") {
            return buildingSelectedInWidget;
        }
        if (!isGuard) {
            if (openingSelectedInWidget) {
                if (buildingSelectedInWidget) {
                    return languages[languageDetected].buildingWithoutOrMoreAreas;
                }
                return languages[languageDetected].openingWithoutOrMoreBuildings;
            }
            if (buildingSelectedInWidget) {
                return languages[languageDetected].buildingWithoutOrMoreAreas;
            }
            return resourcesInPlant
        }
        return resourcesInPlant
    }

    if (instanceHasOpenings) {
        if (instanceHasBuildings) {
            //buildings
            if (levelSelected === levels[1]) {
                if (isGuard) {
                    return languages[languageDetected].buildingSelected
                }
                return languages[languageDetected].buildingsResources;
            }
            if (levelSelected === levels[2]) {
                if (isGuard) {
                    return languages[languageDetected].areasSelectedWithOpening
                }
                return languages[languageDetected].areasSelectedWithOpening;
            }
        }
        //openings
        if (levelSelected === levels[0]) {
            if (isGuard) {
                return languages[languageDetected].openingSelected
            }
            return languages[languageDetected].openingResources;
        }
    }

    if (instanceHasBuildings) {
        if (levelSelected === levels[0]) {
            if (isGuard) {
                return languages[languageDetected].buildingSelected
            }
            return languages[languageDetected].onlyBuildings;
        }

        if (levelSelected === levels[1]) {
            if (isGuard) {
                return languages[languageDetected].areasSelectedWithBuilding;
            }
            return languages[languageDetected].areasSelectedWithBuilding;
        }
    }

    return resourcesInPlant;
}

export const goBackOneLevel = (levelSelected, levels) => {
    const pos = levels.indexOf(levelSelected);
    return levels[pos - 1] ? levels[pos - 1] : null
}